export default __webpack_public_path__ + "static/media/fbicon.3fbf50a7.svg";